import { render, staticRenderFns } from "./MyFindGoods.vue?vue&type=template&id=2b840ec0&scoped=true"
import script from "./MyFindGoods.vue?vue&type=script&lang=js"
export * from "./MyFindGoods.vue?vue&type=script&lang=js"
import style0 from "./MyFindGoods.vue?vue&type=style&index=0&id=2b840ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b840ec0",
  null
  
)

export default component.exports